import { Fragment, useEffect, useState } from 'react'
import axios from "axios";
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Link, Navigate } from 'react-router-dom'
import { FcNightPortrait } from "react-icons/fc";


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ProfileDropdown() {
    const [redirect, setRedirect] = useState(false);

    // const [user, setUser] = useState(new User());
  
    //   useEffect(  () =>{
    //     (
    //      async () => {
    //         const {data} = await axios.get("user");
    //         setUser(new User(
    //           data.id,
    //           data.first_name,
    //           data.last_name,
    //           data.email,
    //           data.role
    //         ));
    //      }
    //     )();
    //   }, []);

    const logout = async () =>{
        await axios.post('logout',{});
        setRedirect(true);
    }

    if(redirect){
        return <Navigate to={'/login'} />;
    }
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100">
        
            <FcNightPortrait className="text-3xl" />
        
          <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="#"
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  View Profile
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <Link
                to="#"
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  Change Password
                </Link>
              )}
            </Menu.Item>
          </div>
          <div className="py-1">
            
            <Menu.Item>
              {({ active }) => (
               <Link
               to="#"
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}

                  onClick={logout}
                >
                 Logout
                </Link>
              )}
            </Menu.Item>
          </div>
         
        </Menu.Items>
      </Transition>
    </Menu>
  )
}